<template>
  <div
    :itemscope="useSchema"
    :itemtype="useSchema ? 'http://schema.org/ImageObject' : undefined"
    :class="[
      'product-card',
      'js-test-list-model',
      'p-card',
      { skeleton: !model.id },
      { viewed },
    ]"
    :data-lazy="lazyImg && model.id ? model.id : null"
    :data-id="!offers && model.id ? model.id : null"
    :data-rid="model && model.id"
  >
    <div
      ref="card"
      class="product-card__analytics"
      :data-slot="position"
      :data-url="objToBase64({ url: model.view_url })"
      :data-block="blockType"
      :data-type="'model'"
      :data-offer_id="model.id ? model.id : ''"
      :data-rid="model && model.id"
    />
    <DebugInfo v-if="debugPanel" type="model" :data="model" />

    <div v-if="model.id" class="product-card__wrapper">
      <div class="product-card__picture-section">
        <div class="product-card__slider">
          <ui-product-card-slider
            :model="model"
            :lazy-img="lazyImg"
            :index="index"
            :offers="offers"
            type="model"
            block-type="list"
            :position="position"
            :model-path="modelPath"
            :use-schema="useSchema"
          />
        </div>
        <div class="product-card__icons">
          <ui-ui-button-ico
            icon="favorites"
            size="medium"
            size-ico="24"
            type="tertiary"
            :fill="favorite ? '#363EF8' : 'white'"
            :stroke="favorite ? '#363EF8' : '#86888F'"
            @click.prevent="toggleFavorite"
          />

          <ui-ui-button-ico
            icon="compare"
            size="medium"
            size-ico="24"
            type="tertiary"
            :fill="inCompare ? '#363EF8' : 'white'"
            :stroke="inCompare ? '#363EF8' : '#86888F'"
            @click.prevent.stop="toggleCompare"
          />
        </div>
      </div>
      <div class="product-card__info-description">
        <div
          v-if="isMinPrice || discountMax >= 10"
          class="sticker-monitoring-wrap sticker-monitoring-wrap__mobile"
        >
          <UiStickerMonitoring
            :type="isMinPrice ? 'minimal' : 'percent-sale'"
            :text="discountMax || 0"
          />
        </div>

        <div class="offer-price">
          <Currency
            v-if="!notInStock && isMobile"
            :value="ProductPrice"
            :link="isMobile ? modelPath : ''"
            prefix="от"
            class="product-card__price price-s"
          />
          <Currency
            v-if="!notInStock && isMobile && isBot"
            :value="ProductPriceMax"
            prefix="до"
            class="product-card__price price-s product-card__price_mobile"
          />
          <div
            v-if="notInStock && isMobile"
            class="product-card__price price-s"
          >
            Нет в продаже
          </div>
        </div>
        <nuxt-link :to="modelPath" class="product-card__title-link">
          <div
            class="product-card__title body-l-medium"
            :itemprop="useSchema ? 'name' : undefined"
          >
            {{ model.title }}
          </div>
        </nuxt-link>

        <div
          v-if="model.description || modelSpecification"
          class="product-card__characteristic"
          :itemprop="useSchema ? 'description' : undefined"
        >
          <div class="specifications-curtain" />
          <div class="specifications-wrapper">
            <component
              :is="isMobile ? HorizontalScroll : 'div'"
              class="specifications-container"
            >
              <div class="product-card__visio">
                <ratingMerchant
                  class="product-card__visio--item"
                  :rating="model.rating"
                  :model="model"
                  :model-path="modelPath"
                />
                <modelViews
                  class="product-card__visio--item"
                  :count-views="countViews"
                  is-atom
                />
              </div>
              <div
                v-for="(spec, ii) in modelSpecification"
                :key="`spec-${ii}`"
                class="specifications"
              >
                <span class="label body-m-regular">{{ spec.title }}: </span>
                <span class="value body-m-regular">{{ spec.value }}</span>
              </div>
            </component>
          </div>
        </div>
        <div class="l-only-mobile">
          <div v-if="isMobile" class="product-card__buttons">
            <ui-ui-button
              mode="link"
              :resize="true"
              size="medium"
              type="primary"
              font-class="body-m-regular"
              class="product-card__button"
              :path="modelPath"
              :loading="!model.id"
              :counter="model.offer_count"
              @click="sendYaSravnitCeni()"
            >
              <template v-if="model.offer_count > 0">
                <span class="desktop-only">Сравнить цены</span>
                <span class="mobile-only">Все цены</span>
              </template>
            </ui-ui-button>
          </div>
          <div
            v-if="isMobile && shopRatingHighCount"
            class="product-card__basement"
          >
            <storeRating
              :count-shops="shopRatingHighCount"
              :merchant-rating="merchantRatingCount"
            />
          </div>
        </div>
      </div>
      <div class="product-card__shop-section">
        <div
          v-if="isMinPrice || discountMax >= 10"
          class="sticker-monitoring-wrap"
        >
          <UiStickerMonitoring
            :type="isMinPrice ? 'minimal' : 'percent-sale'"
            :text="discountMax || 0"
          />
        </div>

        <template v-if="!notInStock">
          <div v-if="!OffersList && !props.isBot">
            <div class="product-card-list-model__preloader"></div>
            <div class="product-card-list-model__preloader"></div>
            <div class="product-card-list-model__preloader"></div>
          </div>
          <div v-if="props.isBot">
            <Currency
              :value="ProductPrice"
              prefix="от"
              class="product-card__price price-s"
            />
            <Currency
              :value="ProductPriceMax"
              prefix="до"
              class="product-card__price price-s"
            />
          </div>
          <template v-if="OffersList">
            <div class="offer-price">
              <Currency
                v-if="!notInStock"
                :value="ProductPrice"
                prefix="от"
                class="product-card__price price-s"
              />
              <div v-else class="product-card__price price-s">
                Нет в продаже
              </div>
            </div>
            <template v-for="(offer, iii) in OffersList">
              <cpc-link
                v-if="!isPlaceOrder(offer)"
                :key="`offer-link-${offer.id}`"
                class="product-card__offers"
                :to="offer.click_url"
                :offer="offer"
                :position="iii + 1"
                :block-type="`${blockType}_${position}_of`"
              >
                <offer-delivery :model="offer" />
              </cpc-link>
              <div
                v-else
                :key="`offer-div-${offer.id}`"
                class="product-card__offers pointer"
                @click="
                  openOrderModal(offer, `${blockType}_${position}_of`, iii + 1)
                "
              >
                <offer-delivery :model="offer" />
              </div>
            </template>
          </template>
          <template v-else>
            <div
              v-for="n in model.offer_count > 4 ? 3 : model.offer_count"
              :key="`count-${n}`"
              class="p-card__offers skeleton"
            />
          </template>
        </template>
        <div v-if="notInStock" class="p-card__price text-subtitle-price-bold">
          Нет в продаже
        </div>
        <template v-if="!notInStock || !model.id">
          <ui-ui-button
            mode="link"
            :resize="true"
            size="medium"
            type="primary"
            class="p-card__button"
            font-class="body-m-regular"
            :path="modelPath"
            :loading="!model.id"
            :counter="model.offer_count"
            @click="sendYaSravnitCeni()"
          >
            Сравнить цены
          </ui-ui-button>
          <div
            v-if="!isMobile && shopRatingHighCount"
            class="product-card__basement"
          >
            <storeRating
              :count-shops="shopRatingHighCount"
              :merchant-rating="merchantRatingCount"
            />
          </div>
          <div
            v-if="!isMobile"
            class="product-card__basement model"
            style="display: none"
          ></div>
        </template>
      </div>
    </div>
    <div v-else class="product-card__wrapper">
      <div class="product-card__picture-section">
        <div class="skeleton_img field" />
      </div>
      <div class="product-card__info-description">
        <div class="offer-price field" />
        <div class="product-card__title field" />
        <div v-for="n in 3" :key="`offer-${n}`" class="offer-price field" />
      </div>
      <div v-if="!isMobile" class="product-card__shop-section">
        <div v-for="n in 4" :key="`offer-${n}`" class="offer-price field" />
        <div class="field reg-btn-container" />
      </div>
      <div class="p-card__price" />
    </div>
  </div>
</template>
<script setup lang="ts">
import OfferDelivery from './OfferDelivery.vue';
import HorizontalScroll from '~/components/ui/horizontal-scroll/HorizontalScroll.vue';
import cpcLink from '~/components/ui/CpcLink.vue';
import DebugInfo from '~/components/debug-info/DebugInfo.vue';
import Currency from '~/components/ui/currency/Currency.vue';
import { useFavoriteStore } from '~/stores/favorite';
import { useCompareStore } from '~/stores/compare';
import { useMediaQueryStore } from '~/stores/mediaQuery';
import { useAnalyticsStore } from '~/stores/analytics';
import { useGlobalStore } from '~/stores/global';
import { useInteractiveStore } from '~/stores/interactive';
import storeRating from '~/components/ui/storeRating/storeRating.vue';
import modelViews from '~/components/page-model/model-views/ModelViews.vue';
import ratingMerchant from '~/components/ui/rating-merchant/rating-merchant.vue';
import { useTimeCalculation } from '~/composition/useTimeCalculation';
import type { ModelOfferItem } from '~/interfaces/api';
import { useModalsStore } from '~/stores/modals';
import { objToBase64 } from '~/utils/base64';

const props = defineProps({
  model: {
    type: Object as () => any,
  },
  offers: Array,
  lazyImg: {
    type: Boolean,
    default: false,
  },
  nuxtLazy: {
    type: Boolean,
    default: false,
  },
  isBot: {
    type: Boolean,
    default: false,
  },
  viewed: {
    type: Boolean,
    default: false,
  },
  position: {
    type: Number,
    default: 1,
  },
  blockType: {
    type: String,
    default: 'listing',
  },
  useSchema: Boolean,
  addFilterQuery: {
    type: String,
    default: '',
  },
  showMoreButton: {
    type: Boolean,
    default: false,
  },
  index: {
    type: Number,
    default: 0,
  },
  discountMax: {
    type: Number,
    default: 0,
  },
  shopRatingHighCount: {
    type: Number,
    default: 0,
  },
  visitCount: {
    type: Number,
    default: 0,
  },
});
const card = ref<HTMLElement | undefined>();
const showButtonMoreOnDesktop = ref(false);
const favoriteStore = useFavoriteStore();
const compareStore = useCompareStore();
const storeMedia = useMediaQueryStore();
const analyticsStore = useAnalyticsStore();
const globalStore = useGlobalStore();
const interactiveStore = useInteractiveStore();
const modalsStore = useModalsStore();
const { $ymAnyEvent, $ymAnyEventWithParam } = useNuxtApp();
const isFirstInteractive = computed(() => interactiveStore.isFirstInteractive);
const debugPanel = computed(() => globalStore.debugPanel);
const isMobile = computed(() => storeMedia.isMobile);
const cardDescriptionView = ref<boolean>(false);
const cardDescription = ref<HTMLElement>();
const isMinPrice = computed(() => props.model?.has_min_price);
const OffersList = computed(() => {
  if (props.model?.offers) return props.model.offers.slice(0, 3);
  else {
    return props.offers ? props.offers.slice(0, 3) : null;
  }
});
const ProductPrice = computed(() => {
  if (props.model) {
    return props.model?.price_info?.min || '';
  }
  return '';
});
const ProductPriceMax = computed(() => {
  if (props.model) {
    return props.model?.price_info?.max || '';
  }
  return '';
});
const modelSpecification = computed(() => {
  return props.model?.specifications?.slice(0, 5);
});
const countViews = computed(() => {
  return props.model?.visit_count || props.visitCount;
});
// TODO Заменить на протоколы получения данных когда сделают бэк
const merchantRatingCount = 4.5;
// TODO end
const notInStock = computed(() => {
  return !props.model.offer_count || null;
});

const inCompare = computed(
  () =>
    props.model &&
    compareStore.ids.find(
      (id: number) => Number(id) === Number(props.model?.id)
    )
);

const modelPath = computed(() => {
  const model = props.model;
  if (!model) return '';
  const slug = model?.slug || '';
  if (!props.addFilterQuery) return `/${slug}/`;
  return `/${slug}/?${props.addFilterQuery}`;
});

const favorite = computed(
  () =>
    props.model &&
    favoriteStore.ids.find(
      (id: number) => Number(id) === Number(props.model?.id)
    )
);
const toggleFavorite = () => {
  if (props.model)
    favoriteStore.toggleFavorite({
      id: props.model.id,
      catId: +props.model.category.id,
      deleteCard: !!favorite.value,
    });
};
const toggleCompare = () => {
  if (props.model) {
    compareStore.toggleCompare({
      id: props.model.id,
      catId: +props.model.category.id,
      deleteCard: !!inCompare.value,
    });
  }
  if (inCompare.value) {
    $ymAnyEvent('reachGoal', 'Compare');
  }
};

const sendYaSravnitCeni = () => {
  $ymAnyEventWithParam('reachGoal', 'click_na_sravnit_ceni', {
    discount_max: props.discountMax,
    visit_count: props.visitCount,
    shop_rating_high_count: props.shopRatingHighCount,
  });
};
const isPlaceOrder = (offer: ModelOfferItem) => offer?.cpo;
const openOrderModal = (
  offer: ModelOfferItem,
  blockType: string,
  position: number
) => {
  modalsStore.setData({
    name: 'order',
    data: {
      offer,
      position,
      blockType,
    },
  });
};
useTimeCalculation();

onMounted(() => {
  if (cardDescription.value)
    cardDescription.value?.offsetHeight > 42
      ? (cardDescriptionView.value = true)
      : (cardDescriptionView.value = false);
  if (card.value)
    nextTick(() => {
      if (card.value) {
        analyticsStore.observeView(card.value);
      }
      if (!props.isBot) {
        showButtonMoreOnDesktop.value = true;
      }
    });
});
onBeforeUnmount(() => {
  if (card.value) analyticsStore.unobserveView(card.value);
});
</script>
<style scoped lang="scss" src="./productCardListModelScss.scss" />
